
import { deserialize } from "serializr";
import _axiosInstance from "../../interceptor/_axiosInstance";
import { InstituteLeaderboard } from "../../models/InstituteModel/leaderboard.model";
import { INSTITUTE_LEADERBOARD } from "../../routes/routeConstants/apiRoutes";

export class StudentLeaderboardService {
  static fetchLeaderboardData(
    queryParams: any,
    onSuccess: (value: InstituteLeaderboard) => void,
    onError: Function,
    onFinal: () => void
  ) {  
    return _axiosInstance
      .get(INSTITUTE_LEADERBOARD, {
        params: queryParams
    })
      .then((response) => {
        const data = deserialize(
          InstituteLeaderboard,
          response["data"]?.['studentLeaderboard']
        );
        onSuccess(data);
      })
      .catch((e) => {
        console.log(e);
        
        onError(e);
      })
      .finally(onFinal);
  }
}
